import React from 'react';
import AdminDocument from '../../features/legal/AdminDocument';
export default function TermsOfUseAdmin() {
  return <AdminDocument type="terms" />;
}
